import Layout from '@/components/Layout'
/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    name: '首页',
    children: [
      {
        path: '/home',
        name: '网站首页',
        component: () => import('@/components/oh/Index')
      },
      {
        path: '/about',
        name: '公司简介',
        component: () => import('@/components/oh/About')
      },
      {
        path: '/product',
        name: '产品中心',
        redirect: '/product/index',
        component: () => import('@/components/oh/Product'),
        children: [
          {
            path: '/product/index',
            name: '产品中心首页',
            component: () => import('@/components/oh/ProductList')
          },
          {
            path: '/product/:pId',
            name: '产品详情',
            component: () => import('@/components/oh/ProductDetail'),
            props: true
          }
        ]
      },
      {
        path: '/contractUs',
        name: '联系我们',
        component: () => import('@/components/oh/ContractUs')
      },
      {
        path: '/news',
        name: '新闻中心',
        redirect: '/news/index',
        component: () => import('@/components/oh/News'),
        children: [
          {
            path: '/news/index',
            name: '新闻中心首页',
            component: () => import('@/components/oh/NewsList')
          },
          {
            path: '/news/:id',
            name: '新闻详情',
            component: () => import('@/components/oh/NewsDetail'),
            props: true
          }
        ]
      },
    ]
  }

]
